import { Box, Card, CardContent, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import AnimatedNumber from "../../common/components/AnimatedNumber";

const PayoutSummaryCard = ({ summary, waterfall }) => {
  const { t } = useTranslation("financials");

  if (!summary) return null;

  const grossRevenue = waterfall?.gross_revenue || 0;
  const netMargin =
    grossRevenue > 0
      ? ((waterfall?.net_after_expenses / grossRevenue) * 100).toFixed(1)
      : 0;

  return (
    <Card variant="outlined" sx={{ mb: 3 }}>
      <CardContent>
        <Typography
          variant="h6"
          sx={{
            textTransform: "uppercase",
            fontWeight: 500,
            fontSize: "0.875rem",
            color: "text.secondary",
            mb: 2,
          }}
        >
          {t("payoutSummary.title")}
        </Typography>
        <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
          <Box>
            <Typography variant="body2" color="text.secondary">
              {t("payoutSummary.grossRevenue")}
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: "bold" }}>
              <AnimatedNumber
                section="statsCards"
                value={grossRevenue}
                isCurrency
              />
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" color="text.secondary">
              {t("payoutSummary.netMargin")}
            </Typography>
            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                color: netMargin >= 0 ? "success.main" : "error.main",
              }}
            >
              {netMargin}%
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" color="text.secondary">
              {t("payoutSummary.totalPaidOut")}
            </Typography>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", color: "success.main" }}
            >
              <AnimatedNumber
                section="statsCards"
                value={summary.total_paid_out}
                isCurrency
              />
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" color="text.secondary">
              {t("payoutSummary.totalOutstanding")}
            </Typography>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", color: "warning.main" }}
            >
              <AnimatedNumber
                section="statsCards"
                value={summary.total_outstanding}
                isCurrency
              />
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" color="text.secondary">
              {t("payoutSummary.producerCount")}
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: "bold" }}>
              <AnimatedNumber
                section="statsCards"
                value={summary.producer_count}
              />
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default PayoutSummaryCard;
